import React from "react";

import { Colors, ColorSchemes, IThemeColor } from "./colors";
import { ITheme, Theme } from "./index";

interface IThemeContext {
  colorScheme: ColorSchemes;
  colors: IThemeColor;
  theme: ITheme;
}

const ThemeContext = React.createContext<IThemeContext>({
  colorScheme: ColorSchemes.LIGHT,
  colors: Colors[ColorSchemes.LIGHT],
  theme: Theme,
});

export { ThemeContext };
